import React from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

interface Props {
    title: string;
    showBack?: boolean;
    backRoute?: string;
}

const ZapMobileHeader: React.FC<Props> = ({ title, showBack = true, backRoute = '/influencer/zap' }) => {
    const navigate = useNavigate();
    return (
        <Box sx={{
            display: { xs: 'flex', sm: 'none' },
            position: 'fixed',
            top: 0, left: 0, right: 0,
            zIndex: 100,
            bgcolor: '#fff',
            alignItems: 'center',
            px: 1.5,
            height: 56,
            borderBottom: '1px solid #f0f0f0',
            boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        }}>
            <Box sx={{ width: 40, display: 'flex', alignItems: 'center' }}>
                {showBack && (
                    <Box
                        onClick={() => navigate(backRoute)}
                        sx={{
                            width: 36, height: 36,
                            borderRadius: '50%',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            cursor: 'pointer',
                            '&:active': { bgcolor: '#f5f5f5' },
                        }}
                    >
                        <ArrowBackIosNewIcon sx={{ fontSize: 18, color: '#111' }} />
                    </Box>
                )}
            </Box>
            <Typography
                variant="subtitle1"
                fontWeight={700}
                sx={{ flex: 1, textAlign: 'center', letterSpacing: '-0.2px', fontSize: '1rem', color: '#111' }}
            >
                {title}
            </Typography>
            <Box sx={{ width: 40 }} />
        </Box>
    );
};

export default ZapMobileHeader;
